module.exports = __webpack_public_path__ + "img/group.bc34ad38.png";